module.exports = __webpack_public_path__ + "static/Podcast01-6c3a5933123f1f78aecc9c83a51b83f7.jpg";